<app-modal-main class="call-us-modal">
  @if (step === 1) {
    <app-modal-sidebar [logo-position]="'top'">
      <app-contact-informations></app-contact-informations>
    </app-modal-sidebar>
    <app-modal-main-content>
      <app-modal-header>
        <app-modal-title>{{ 'modals.callUs.title' | translate }}</app-modal-title>
        <app-paragraph [font-size]="'small'"> {{ 'modals.callUs.description' | translate }}<br /> </app-paragraph>
      </app-modal-header>
      <app-form [formGroup]="form" (submited)="send()">
        <app-form-section>
          <app-form-title>{{ 'forms.contactInformations' | translate }}</app-form-title>
          <app-form-inputs>
            <app-input [label]="'forms.nameAndSurname' | translate" [required]="true" [name]="'name'" [formControlName]="'name'" [error]="form.controls['name'].invalid && form.controls['name'].touched" [error-message]="'forms.inputError' | translate"></app-input>
            <app-grid [template]="'102px auto'" [gap]="4">
              <app-phone-input [formControlName]="'phoneCode'"></app-phone-input>
              <app-input
                [label]="'forms.phone' | translate"
                [type]="'number'"
                [pattern]="'[0-9]*'"
                [required]="true"
                [name]="'phone'"
                [formControlName]="'phone'"
                [error]="form.controls['phone'].invalid && form.controls['phone'].touched"
                [error-message]="form.controls.phone.hasError('phone') ? ('forms.inputTypeError' | translate: { name: 'forms.phone' | translate }) : ('forms.inputError' | translate)"
              ></app-input>
            </app-grid>
            <app-input
              [label]="'forms.email' | translate"
              [type]="'email'"
              [required]="true"
              [name]="'email'"
              [formControlName]="'email'"
              [error]="form.controls['email'].invalid && form.controls['email'].touched"
              [error-message]="form.controls.email.hasError('email') ? ('forms.inputTypeError' | translate: { name: 'forms.email' | translate }) : ('forms.inputError' | translate)"
            ></app-input>
          </app-form-inputs>
        </app-form-section>
        <app-form-section>
          <app-form-title>{{ 'modals.callUs.dateAndTime' | translate }}</app-form-title>
          <app-form-inputs>
            <app-grid [template]="'repeat(2, 1fr)'" [gap]="8">
              <app-input [label]="'forms.date' | translate" [required]="true" [type]="'date'" [formControlName]="'date'" [name]="'date'" [error]="form.controls['date'].invalid && form.controls['date'].touched" [error-message]="'forms.inputError' | translate"></app-input>
              <app-select [label]="'forms.time' | translate" [required]="true" [icon]="'time'" [formControlName]="'time'" [name]="'time'" [error]="form.controls['time'].invalid && form.controls['time'].touched" [error-message]="'forms.inputError' | translate">
                @for (item of timeOptions; track $index) {
                  <app-select-item [value]="item">{{ item }}</app-select-item>
                }
              </app-select>
            </app-grid>
            <app-checkbox [formControlName]="'marketingAgree'" [name]="'marketingAgree'">{{ 'forms.marketingAgree' | translate }}</app-checkbox>
          </app-form-inputs>
        </app-form-section>
        <app-button [type]="'submit'" [size]="'large'">{{ 'modals.callUs.button' | translate }}</app-button>
      </app-form>
      <app-paragraph [font-size]="'small'">
        {{ 'forms.personalAgree' | translate }} <app-link [href]="globals.routes()['gdpr'].url" [target]="'_blank'">{{ 'forms.personalAgreeLink' | translate }}</app-link
        >.
      </app-paragraph>
    </app-modal-main-content>
  } @else {
    <app-modal-main-content>
      <app-form-thanks-message [type]="'modal'"></app-form-thanks-message>
    </app-modal-main-content>
  }
</app-modal-main>
